/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, the lines are gently smoothed for readability while still passing through your data points.`)
};

const es_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, las líneas se suavizan ligeramente para mayor legibilidad, aunque siguen pasando por tus puntos de datos.`)
};

const de_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, die Linien werden zur besseren Lesbarkeit leicht geglättet, während sie weiterhin durch Ihre Datenpunkte verlaufen.`)
};

const nl_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, de lijnen worden licht afgevlakt voor leesbaarheid, terwijl ze nog steeds door je datapunten lopen.`)
};

const fr_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, les courbes sont légèrement lissées pour la lisibilité tout en passant par vos points de données.`)
};

const it_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, le linee sono leggermente smussate per una migliore leggibilità pur passando esattamente per i tuoi punti dati.`)
};

const pt_br2_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, as linhas são levemente suavizadas para melhor leitura, embora ainda passem pelos seus pontos de dados.`)
};

const pt_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, as linhas são suavemente suavizadas para melhor leitura, continuando a passar pelos seus pontos de dados.`)
};

const ja_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、読みやすさのために線は緩やかに平滑化されますが、データポイントは正確に通過します。`)
};

const zh_line_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，线条经过轻微平滑处理以提高可读性，同时仍然经过你的数据点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_a3", locale)
	if (locale === "en") return en_line_faq_a3(inputs)
	if (locale === "es") return es_line_faq_a3(inputs)
	if (locale === "de") return de_line_faq_a3(inputs)
	if (locale === "nl") return nl_line_faq_a3(inputs)
	if (locale === "fr") return fr_line_faq_a3(inputs)
	if (locale === "it") return it_line_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_a3(inputs)
	if (locale === "pt") return pt_line_faq_a3(inputs)
	if (locale === "ja") return ja_line_faq_a3(inputs)
	return zh_line_faq_a3(inputs)
};